<div class="entity-actions">
  @if (mocketBankAccount?.state !== 'SUSPENDED') {
    <button
      class="action-button action-button-suspend"
      [disabled]="isControlsDisabled | accessControl | async"
      (click)="btnClicked.emit('SUSPEND')"
      title="Suspend Account"
    >
      <rkt-icon name="suspend"></rkt-icon>
    </button>
  } @else if (mocketBankAccount?.state === 'SUSPENDED') {
    <button
      class="action-button action-button-unsuspend"
      [disabled]="isControlsDisabled | accessControl | async"
      (click)="btnClicked.emit('UNSUSPEND')"
      title="Unsuspend Account"
    >
      <rkt-icon name="resume"></rkt-icon>
    </button>
  }
  <button
    class="action-button action-button-delete"
    [disabled]="isControlsDisabled | accessControl | async"
    (click)="btnClicked.emit('DELETE')"
    title="Delete Account"
  >
    <rkt-icon name="trash"></rkt-icon>
  </button>
</div>
